/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import SpacingTable from 'Docs/uilib/layout/spacing-table.mdx';
import * as Examples from 'Docs/uilib/layout/space/Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    code: "code",
    a: "a",
    h3: "h3",
    ul: "ul",
    li: "li",
    strong: "strong",
    em: "em",
    pre: "pre",
    ol: "ol"
  }, _provideComponents(), props.components);
  if (!Examples) _missingMdxReference("Examples", false);
  if (!Examples.Components) _missingMdxReference("Examples.Components", true);
  if (!Examples.FourDirections) _missingMdxReference("Examples.FourDirections", true);
  if (!Examples.SameResult1) _missingMdxReference("Examples.SameResult1", true);
  if (!Examples.SameResult2) _missingMdxReference("Examples.SameResult2", true);
  if (!Examples.Shorthand) _missingMdxReference("Examples.Shorthand", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Description"
    }), "\n", _jsxs(_components.p, {
      children: ["The Space component provides ", _jsx(_components.code, {
        children: "margins"
      }), " within the ", _jsx(_components.a, {
        href: "/uilib/usage/layout/spacing#spacing-helpers",
        children: "provided spacing patterns"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "The reason why this exists is to make your syntax as clean as possible.\nThis way you see directly in words what the spacing is for every affected component"
    }), "\n", _jsx(_components.h3, {
      children: "Spacing Table"
    }), "\n", _jsx(SpacingTable, {}), "\n", _jsx(_components.h3, {
      children: "Value Format"
    }), "\n", _jsx(_components.p, {
      children: "There are a couple of different ways you can define the spacing types and values:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Types:"
        }), " ", _jsx(_components.code, {
          children: "small small x-small"
        }), " (combine types up to ", _jsx(_components.em, {
          children: "10rem"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "number:"
        }), " ", _jsx(_components.code, {
          children: "2.5"
        }), " (equivalent to ", _jsx(_components.code, {
          children: "rem"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "string(rem):"
        }), " ", _jsx(_components.code, {
          children: "2.5rem"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "string(px):"
        }), " ", _jsx(_components.code, {
          children: "40px"
        }), " (gets converted to ", _jsx(_components.code, {
          children: "rem"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "boolean:"
        }), " ", _jsx(_components.code, {
          children: "true"
        }), " (equivalent to ", _jsx(_components.code, {
          children: "small"
        }), "), ", _jsx(_components.code, {
          children: "false"
        }), " (equivalent to ", _jsx(_components.code, {
          children: "zero"
        }), ")"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["To get a spacing of e.g. ", _jsx(_components.strong, {
        children: "2.5rem"
      }), " (40px)- you may combine types ", _jsx(_components.code, {
        children: "large"
      }), " and ", _jsx(_components.code, {
        children: "x-small"
      }), "."]
    }), "\n", _jsx(Examples.SameResult1, {}), "\n", _jsx(_components.p, {
      children: "With React, you can also use an object with the different directions:"
    }), "\n", _jsx(Examples.SameResult2, {}), "\n", _jsx(_components.h3, {
      children: "Components and Spacing"
    }), "\n", _jsxs(_components.p, {
      children: ["Every component supports the spacing patterns, so it's possible to send in the ", _jsx(_components.code, {
        children: "top"
      }), ", ", _jsx(_components.code, {
        children: "right"
      }), ", ", _jsx(_components.code, {
        children: "bottom"
      }), ", ", _jsx(_components.code, {
        children: "left"
      }), " and ", _jsx(_components.code, {
        children: "space"
      }), " properties directly, like:"]
    }), "\n", _jsx(Examples.Components, {}), "\n", _jsx(_components.h3, {
      children: "Spacing shorthands"
    }), "\n", _jsx(_components.p, {
      children: "A shorthand for getting 1rem (most used) is to simply send in a boolean, set as true. No given value in JSX means true, so you only need the property key:"
    }), "\n", _jsx(Examples.Shorthand, {}), "\n", _jsxs(_components.p, {
      children: ["In order to set all four directions at once, you can provide a string as the ", _jsx(_components.code, {
        children: "space"
      }), " value:"]
    }), "\n", _jsx(Examples.FourDirections, {}), "\n", _jsx(_components.h3, {
      children: "Does it not work as expected?"
    }), "\n", _jsxs(_components.p, {
      children: ["Is ", _jsx(_components.code, {
        children: "margin"
      }), " not giving the expected spacing? That may be the reason due to ", _jsx(_components.strong, {
        children: "Margin Collapsing"
      }), ". Margins collapse in the following situations:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Adjacent siblings"
      }), "\n", _jsx(_components.li, {
        children: "Completely empty boxes"
      }), "\n", _jsx(_components.li, {
        children: "Parent and first or last child element"
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["The best solution is to only use one direction of margins e.g. ", _jsx(_components.code, {
        children: "bottom"
      }), ". Or you can set the ", _jsx(_components.a, {
        href: "/uilib/layout/space/properties",
        children: "collapse property"
      }), " to ", _jsx(_components.code, {
        children: "false"
      }), "."]
    }), "\n", _jsx(_components.h3, {
      children: "Margin collapsing"
    }), "\n", _jsxs(_components.p, {
      children: ["In order to help out to handle unwanted margin collapsing in typography elements, se ", _jsx(_components.a, {
        href: "/uilib/elements/heading#example-of-margin-collapsing",
        children: "this example"
      })]
    }), "\n", _jsx(_components.h3, {
      children: "Conditional Rest"
    }), "\n", _jsxs(_components.p, {
      children: ["For resetting spacing (", _jsx(_components.code, {
        children: "margin: 0"
      }), ") only when no spacing is defined, you can make use of ", _jsx(_components.code, {
        children: "dnb-space__reset"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["The following example will result in ", _jsx(_components.code, {
        children: "margin: 0.5rem 0 0 0"
      }), ":"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-html",
        children: "<ul class=\"my-list dnb-space__reset dnb-space__top--small\">\n  <!-- some content -->\n</ul>\n"
      })
    }), "\n", _jsx(_components.p, {
      children: "More details:"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "Because of the browser default styles, our list has some margin."
      }), "\n", _jsxs(_components.li, {
        children: ["If we would want to \"reset\" these styles to a margin of 0 directly on ", _jsx(_components.code, {
          children: ".my-list"
        }), ", we would not be able to use ", _jsx(_components.code, {
          children: "dnb-space__top--small"
        }), " because of the CSS specificity is lower."]
      }), "\n"]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
